import * as tslib_1 from "tslib";
import * as React from 'react';
import DropDownMenu from 'material-ui/DropDownMenu';
import MenuItem from 'material-ui/MenuItem';
import Avatar from 'material-ui/Avatar';
import UserApi from '../../services/UserApi';
var styles = {
    dropdown: {
        width: '100%'
    },
    dropdownLine: {
        display: 'none'
    },
    menuItem: {
        height: '50px',
        lineHeight: '50px'
    }
};
var UserChooser = /** @class */ (function (_super) {
    tslib_1.__extends(UserChooser, _super);
    function UserChooser(props) {
        var _this = _super.call(this, props) || this;
        _this.handleSelection = function (e, _, value) {
            e.preventDefault();
            _this.props.onSelection(value);
        };
        return _this;
    }
    UserChooser.prototype.render = function () {
        var _this = this;
        var _a = this.props, user = _a.user, users = _a.users;
        var items = users.map(function (i) { return (React.createElement(MenuItem, { style: styles.menuItem, key: i.id, leftIcon: _this.renderAvatar(i), value: i, primaryText: i.name })); });
        return React.createElement(DropDownMenu, { value: user, style: styles.dropdown, onChange: this.handleSelection }, items);
    };
    UserChooser.prototype.renderAvatar = function (user) {
        return React.createElement(Avatar, { src: UserApi.getAvatarUrl(user.id) });
    };
    return UserChooser;
}(React.Component));
export { UserChooser };



//////////////////
// WEBPACK FOOTER
// ./src/pages/statistics/UserChooser.tsx
// module id = 800
// module chunks = 0